export const orderSettingsAdapter = orderSettings => ({
  acceptSpecialRequests: orderSettings == null ? void 0 : orderSettings.acceptSpecialRequests,
  inStock: orderSettings == null ? void 0 : orderSettings.inStock,
  taxGroupId: orderSettings == null ? void 0 : orderSettings.taxGroupId
});
export const priceVariantsAdapter = priceVariants => {
  return priceVariants.map(priceVariant => ({
    variantId: priceVariant.variantId,
    priceInfo: priceVariant.priceInfo
  }));
};
export const modifierGroupRuleAdapter = modifierGroupRule => ({
  minSelections: modifierGroupRule.minSelections,
  maxSelections: modifierGroupRule.maxSelections,
  required: modifierGroupRule.required
});
//# sourceMappingURL=adapters.js.map